import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ClientMerchantsService } from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
import { FidelityService } from 'src/app/services/api/fidelity/fidelity.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { TranslateArrayService } from 'src/app/services/translateArray/translate';

@Component({
  selector: 'app-fidelity',
  templateUrl: './fidelity.component.html',
  styleUrls: ['./fidelity.component.css']
})
export class FidelityComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator|any;
  @ViewChild(MatSort) sort: MatSort|any;

  currMerchant: any;
  merchantClient: any;

  loaders: any = {
    page: true,
    history: true
  };


  statusMessage: any = this.translate.instant('fidelityComponent.messageLoaderGetInfo');

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['date', 'old_value', 'value', 'new_value', 'print'];

  fidelityOffers: any[]|any;

  constructor(
    private clientMerchantApi: ClientMerchantsService,
    private fidelityApi: FidelityService,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private TranslateArrayService: TranslateArrayService
  ) { }

  ngOnInit() {

    this.route.params.subscribe((params:any) => {

      if (params.merchantId) {

        forkJoin(
          this.clientMerchantApi.getMerchant(params.merchantId),
          this.clientMerchantApi.getMerchantClient(params.merchantId)
        ).subscribe(([merchant, merchantClient]) => {

          this.currMerchant = merchant;

          this.merchantClient = merchantClient;


          forkJoin(
            this.fidelityApi.$_getHistory(merchantClient.id, merchant.id_webshop),
            this.fidelityApi.$_getOffers(merchantClient.id, merchant.id_webshop)
          ).subscribe(([history, offers]) => {

            setTimeout(() => {
              this.dataSource.data = history;
              this.dataSource.paginator = this.paginator;

              this.dataSource.sort = this.sort;
              this.dataSource.paginator = this.TranslateArrayService.get(this.dataSource.paginator);
            });

            this.fidelityOffers = offers;

            this.loaders.page = false;
            this.loaders.history = false;

          })

        });

      } else {

        this.router.navigate(["/404", this.translate.instant('error404.Urlincomplet')]);

      }

    });

  }

  goBack(): void {
    this.router.navigate(["/home/merchantOptions" + "/" + this.currMerchant.id_user]);
  }

  goFidelityPrint(fidelity: any): void {

    window.open(fidelity.ticket.url, "_blank");
  }

}
